module.exports = __webpack_public_path__ + "img/Male.63f6fc2b.svg";